"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const errors_1 = require("@ledgerhq/errors");
const errors_2 = require("../../errors");
const account_1 = require("../../account");
const currencies_1 = require("../../currencies");
const logic_1 = require("./logic");
const api_1 = require("./api");
const getTransactionStatus = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const errors = {};
    const warnings = {};
    const useAllAmount = !!t.useAllAmount;
    const destinationNotExistMessage = new errors_1.NotEnoughBalanceBecauseDestinationNotCreated("", {
        minimalAmount: `${api_1.MIN_BALANCE} XLM`,
    });
    if (a.pendingOperations.length > 0) {
        throw new errors_2.AccountAwaitingSendPendingOperations();
    }
    if (!t.fees || !t.baseReserve) {
        errors.fees = new errors_1.FeeNotLoaded();
    }
    const estimatedFees = !t.fees ? new bignumber_js_1.BigNumber(0) : t.fees;
    const baseReserve = !t.baseReserve ? new bignumber_js_1.BigNumber(0) : t.baseReserve;
    const isAssetPayment = t.subAccountId && t.assetCode && t.assetIssuer;
    const nativeBalance = a.balance;
    const nativeAmountAvailable = a.spendableBalance.minus(estimatedFees);
    let amount = new bignumber_js_1.BigNumber(0);
    let maxAmount = new bignumber_js_1.BigNumber(0);
    let totalSpent = new bignumber_js_1.BigNumber(0);
    // Enough native balance to cover transaction (with required reserve + fees)
    if (!errors.amount && nativeAmountAvailable.lt(0)) {
        errors.amount = new errors_2.StellarNotEnoughNativeBalance();
    }
    // Entered fee is smaller than base fee
    if (estimatedFees.lt(((_a = t.networkInfo) === null || _a === void 0 ? void 0 : _a.baseFee) || 0)) {
        errors.transaction = new errors_2.StellarFeeSmallerThanBase();
        // Entered fee is smaller than recommended
    }
    else if (estimatedFees.lt(((_b = t.networkInfo) === null || _b === void 0 ? void 0 : _b.fees) || 0)) {
        warnings.transaction = new errors_2.StellarFeeSmallerThanRecommended();
    }
    // Operation specific checks
    if (t.mode === "changeTrust") {
        // Check asset provided
        if (!t.assetCode || !t.assetIssuer) {
            // This is unlikely
            errors.transaction = new errors_2.StellarAssetRequired("");
        }
        // Has enough native balance to add new trustline
        if (nativeAmountAvailable.minus(api_1.BASE_RESERVE).lt(0)) {
            errors.amount = new errors_2.StellarNotEnoughNativeBalanceToAddTrustline();
        }
    }
    else {
        // Payment
        // Check recipient address
        if (!t.recipient) {
            errors.recipient = new errors_1.RecipientRequired("");
        }
        else if (!(0, logic_1.isAddressValid)(t.recipient)) {
            errors.recipient = new errors_1.InvalidAddress("");
        }
        else if (a.freshAddress === t.recipient) {
            errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
        }
        const recipientAccount = yield (0, logic_1.getRecipientAccount)({
            account: a,
            recipient: t.recipient,
        });
        // Check recipient account
        if (!(recipientAccount === null || recipientAccount === void 0 ? void 0 : recipientAccount.id) && !errors.recipient && !warnings.recipient) {
            if (recipientAccount === null || recipientAccount === void 0 ? void 0 : recipientAccount.isMuxedAccount) {
                errors.recipient = new errors_2.StellarMuxedAccountNotExist();
            }
            else {
                if (isAssetPayment) {
                    errors.recipient = destinationNotExistMessage;
                }
                else {
                    warnings.recipient = destinationNotExistMessage;
                }
            }
        }
        // Asset payment
        if (isAssetPayment) {
            const asset = (0, account_1.findSubAccountById)(a, t.subAccountId || "");
            if (asset === null) {
                // This is unlikely
                throw new errors_2.StellarAssetNotFound();
            }
            // Check recipient account accepts asset
            if ((recipientAccount === null || recipientAccount === void 0 ? void 0 : recipientAccount.id) &&
                !errors.recipient &&
                !warnings.recipient &&
                !recipientAccount.assetIds.includes(`${t.assetCode}:${t.assetIssuer}`)) {
                errors.recipient = new errors_2.StellarAssetNotAccepted("", {
                    assetCode: t.assetCode,
                });
            }
            const assetBalance = (asset === null || asset === void 0 ? void 0 : asset.balance) || new bignumber_js_1.BigNumber(0);
            maxAmount = (asset === null || asset === void 0 ? void 0 : asset.spendableBalance) || assetBalance;
            amount = useAllAmount ? maxAmount : t.amount;
            totalSpent = amount;
            if (!errors.amount && amount.gt(assetBalance)) {
                errors.amount = new errors_1.NotEnoughBalance();
            }
        }
        else {
            // Native payment
            maxAmount = nativeAmountAvailable;
            amount = useAllAmount ? maxAmount : t.amount || 0;
            if (amount.gt(maxAmount)) {
                errors.amount = new errors_1.NotEnoughBalance();
            }
            totalSpent = useAllAmount ? nativeAmountAvailable : t.amount.plus(estimatedFees);
            // Need to send at least 1 XLM to create an account
            if (!errors.recipient && !(recipientAccount === null || recipientAccount === void 0 ? void 0 : recipientAccount.id) && !errors.amount && amount.lt(10000000)) {
                errors.amount = destinationNotExistMessage;
            }
            if (totalSpent.gt(nativeBalance.minus(baseReserve))) {
                errors.amount = new errors_1.NotEnoughSpendableBalance(undefined, {
                    minimumAmount: (0, currencies_1.formatCurrencyUnit)(a.currency.units[0], baseReserve, {
                        disableRounding: true,
                        showCode: true,
                    }),
                });
            }
            if (!errors.recipient && !errors.amount && (amount.lt(0) || totalSpent.gt(nativeBalance))) {
                errors.amount = new errors_1.NotEnoughBalance();
                totalSpent = new bignumber_js_1.BigNumber(0);
                amount = new bignumber_js_1.BigNumber(0);
            }
        }
        if (!errors.amount && amount.eq(0)) {
            errors.amount = new errors_1.AmountRequired();
        }
    }
    if (yield (0, logic_1.isAccountMultiSign)(a)) {
        errors.recipient = new errors_2.StellarSourceHasMultiSign();
    }
    if (t.memoType && t.memoValue && !(0, logic_1.isMemoValid)(t.memoType, t.memoValue)) {
        errors.transaction = new errors_2.StellarWrongMemoFormat();
    }
    return Promise.resolve({
        errors,
        warnings,
        estimatedFees,
        amount,
        totalSpent,
    });
});
exports.default = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map